import React from 'react';
import { useParams } from 'react-router';

import StandardPageTemplate from '../../templates/StandardPage';

const ColorSelectorPage = (): JSX.Element => {
  const { campaignId } = useParams();
  return (
    <StandardPageTemplate>
      Color selector for #{campaignId}.
    </StandardPageTemplate>
  );
};

export default ColorSelectorPage;
